<template>
  <button
    type="button"
    :class="{
      'cta-button': true,
      'is-loading': loading,
      solid,
      red,
      orange,
      'full-width': fullWidth,
    }"
    :disabled="loading"
    v-bind="{ ...$props }"
    @click="handleClick"
  >
    <span v-if="$slots.default">
      <slot />
    </span>
  </button>
</template>

<script>
export default {
  name: "CTAButton",
  props: {
    loading: { type: Boolean, default: false },
    solid: { type: Boolean, default: false },
    red: { type: Boolean, default: false },
    orange: { type: Boolean, default: false },
    fullWidth: { type: Boolean, default: false },
  },
  methods: {
    handleClick(evt) {
      this.$emit("click", evt);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/style/variables.scss";
@import "@/style/mixins.scss";

@mixin solid {
  background-color: $orange;
  border-radius: 2px;
  line-height: 48px;
  color: $white;
  width: 100%;

  &:hover {
    background-color: rgba($orange, 0.85);
  }
}

.cta-button {
  background-color: $white;
  transition: background-color 0.3s;
  border: 1px solid $orange;
  border-radius: 24px;
  color: $orange;
  @include noto;
  font-size: 13.5px;
  font-weight: bold;
  line-height: 38px;
  width: 300px;
  max-width: 100%;
  text-align: center;
  margin: 30px auto 20px;
  display: block;

  &:hover {
    background-color: rgba($orange, 0.15);
  }

  &.solid {
    @include solid;
  }

  &[disabled] {
    opacity: 0.5;
  }

  &.red {
    color: #e1562a;
    border-color: #e1562a;
  }

  &.orange {
    color: #ff9a44;
    border-color: #ff9a44;
  }

  &.full-width {
    width: 100%;
  }

  &.is-loading {
    padding-right: 40px;
    position: relative;

    &::before {
      content: "";
      position: absolute;
      display: block;
      width: 0px;
      height: 0px;
      border-radius: 50%;
      right: 20px;
      top: 50%;
      border: 2px solid rgba(255, 255, 255, 0.4);
      border-right: 2px solid #000;
      animation: rotate360 0.5s infinite linear, exist 0.1s forwards ease;
      z-index: 5;
    }

    @keyframes rotate360 {
      100% {
        transform: rotate(360deg);
      }
    }

    @keyframes exist {
      100% {
        width: 12px;
        height: 12px;
        margin: -8px 5px 0 0;
      }
    }
  }
}
</style>
